import styled from "@emotion/styled";
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import {
  Avatar,
  Box,
  Collapse,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  Tooltip,
  Typography,
  useTheme
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Image from 'react-bootstrap/Image';
import { useDispatch, useSelector } from "react-redux";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import logo from "../assets/images/logo.svg";
import audits from "../assets/images/sideIcons/audits.png";
import brands from "../assets/images/sideIcons/brands.png";
import campaign from "../assets/images/sideIcons/campaign.png";
import company from "../assets/images/sideIcons/company.png";
import dashboard from "../assets/images/sideIcons/dashboard.png";
import kyc from "../assets/images/sideIcons/kyc.png";
import mycampaigns from "../assets/images/sideIcons/mycampaign.png";
import notification from "../assets/images/sideIcons/notification.png";
import privacy from "../assets/images/sideIcons/privacy.png";
import roles from "../assets/images/sideIcons/roles.png";
import subscription from "../assets/images/sideIcons/subscription1.png";
import discovery from "../assets/images/sideIcons/discoverInfluencer.png"
import usermgt from "../assets/images/sideIcons/usermgt.png";
import users from "../assets/images/sideIcons/users.png";
import wallet from "../assets/images/sideIcons/wallet.png";
import { getUserInfoNew } from "../layout/action";
import { getCompanyDetails } from "../pages/company/action";
import { getCompanyid, getCompanyName, getFormatedNumber, getUserType } from "../utils/common";
import { COMPANY, getFixedValue, getFixedValueToNonDecimal } from "../utils/constant";
import { ROUTES } from "../utils/routes";
import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';
import creditWhite from '../assets/images/icons/creditwhite.svg'
import infoWhite from '../assets/images/icons/infowhite.svg'
import user from '../assets/images/icons/user.svg'
import viewSubscription from '../assets/images/icons/viewSubscription.svg'
import manageUser from '../assets/images/icons/manageUser.svg'
import logoutIcon from '../assets/images/icons/logouticon.svg'
import myPlanIcon from '../assets/images/icons/myplan.svg'
import questionCircle from '../assets/images/icons/questionCircle.svg'
import questiongray from '../assets/images/icons/questiongray.svg'
import coinsGold from '../assets/images/icons/goldcoin2.svg'
import diamond from '../assets/images/icons/diamond.svg'
import userCheck from '../assets/images/icons/usercheck2.svg'
import rocket from '../assets/images/icons/rocket2.svg'
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import { setSidebar } from "../redux/reducer";
import list from '../assets/images/sideIcons/listSidebaricon.svg'
import { persistor } from "../redux/store";

const UserInfo = ({planDetails}) => {

  return (
    <>
      <Stack direction="column" gap={1} sx={{ height: '100%', width: '100%', background: 'white', borderRadius: '8px', padding: '0px 15px' }} >
        <Stack direction="row" justifyContent="space-between" alignItems="center" >
          <Typography sx={{ fontWeight: '700', fontFamily: "var(--family1)", fontSize: '14px', display: 'flex', alignItems: 'center' }}>
            <img src={myPlanIcon} alt="myPlanIcon" height={24} width={24} />&nbsp;My Plan&nbsp;<img src={questionCircle} alt="questionCircle" width={16} height={16} />
          </Typography>
          <Typography sx={{ fontWeight: '700', fontFamily: "var(--family1)", fontSize: '14px', background: 'linear-gradient(127deg, rgba(7,213,255,1) 0%, rgba(16,34,121,1) 50%, rgba(188,150,255,1) 100%)', backgroundClip: "text", color: 'transparent' }}>{planDetails?.basicInfo?.name || "N/A"}</Typography>
        </Stack>
        <hr />
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography sx={{ fontWeight: '500', fontFamily: "var(--family1)", fontSize: '14px', display: 'flex', alignItems: 'center' }}>
            <img src={coinsGold} alt="myPlanIcon" height={24} width={24} />&nbsp;Credit Remains&nbsp;<img src={questionCircle} alt="questionCircle" width={16} height={16} />
          </Typography>
          <Typography sx={{ fontWeight: '500', fontFamily: "var(--family1)", fontSize: '14px', }}>{getFixedValue(getFormatedNumber(planDetails?.basicInfo?.useSearchView) + getFormatedNumber(planDetails?.basicInfo?.useProfileView) + getFormatedNumber(planDetails?.basicInfo?.usePhoneNumber) + getFormatedNumber(planDetails?.basicInfo?.useEmail) + getFormatedNumber(planDetails?.basicInfo?.useInfluencerApproved) + getFormatedNumber(planDetails?.basicInfo?.usePaid) + getFormatedNumber(planDetails?.basicInfo?.useBarter) + getFormatedNumber(planDetails?.basicInfo?.useAffiliate) + getFormatedNumber(planDetails?.basicInfo?.usePerformance))}/{getFixedValue(getFormatedNumber(planDetails?.basicInfo?.actualSearchView) + getFormatedNumber(planDetails?.basicInfo?.actualProfileView) + getFormatedNumber(planDetails?.basicInfo?.actualPhoneNumber) + getFormatedNumber(planDetails?.basicInfo?.actualEmail) + getFormatedNumber(planDetails?.basicInfo?.actualInfluencerApproved) + getFormatedNumber(planDetails?.basicInfo?.actualPaid) + getFormatedNumber(planDetails?.basicInfo?.actualBarter) + getFormatedNumber(planDetails?.basicInfo?.actualAffiliate) + getFormatedNumber(planDetails?.basicInfo?.actualPerformance))}</Typography>
        </Stack>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography sx={{ fontWeight: '500', fontFamily: "var(--family1)", fontSize: '14px', display: 'flex', alignItems: 'center', color: '#726C6C' }}>
            <img src={userCheck} alt="myPlanIcon" height={24} width={24} />&nbsp;Approved Influencers&nbsp;<img src={questiongray} alt="questionCircle" width={16} height={16} />
          </Typography>
          <Typography onClick={(e)=>{
            e.preventDefault();
            e.stopPropagation();
          }} sx={{ fontWeight: '600', fontFamily: "var(--family1)", fontSize: '12px', display: 'flex', alignItems: 'center', color: 'white', padding: '5px 10px', borderRadius: '5px',zIndex:'99999999 !important' }} className="upgradePlanButton-hover upgradePlanButton">
            <Link to={`/subscription/active/details/${getCompanyid()}`} className="text-decoration-none" style={{ color: 'white' }}> <img src={diamond} alt="myPlanIcon" height={18} width={18} /> Upgrade</Link>
          </Typography>
        </Stack>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography sx={{ fontWeight: '500', fontFamily: "var(--family1)", fontSize: '14px', display: 'flex', alignItems: 'center', color: '#726C6C' }}>
            <img src={rocket} alt="myPlanIcon" height={24} width={24} />&nbsp;Create Campaign &nbsp;<img src={questiongray} alt="questionCircle" width={16} height={16} />
          </Typography>
          <Typography onClick={(e)=>{
            e.preventDefault();
            e.stopPropagation();
          }} sx={{ fontWeight: '600', fontFamily: "var(--family1)", fontSize: '12px', display: 'flex', alignItems: 'center', color: 'white', padding: '5px 10px', borderRadius: '5px',zIndex:'99999999 !important' }} className="upgradePlanButton-hover upgradePlanButton">
            <Link to={`/subscription/active/details/${getCompanyid()}`} className="text-decoration-none" style={{ color: 'white' }}> <img src={diamond} alt="myPlanIcon" height={18} width={18} /> Upgrade</Link>
          </Typography>
        </Stack>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography sx={{ fontWeight: '700', fontFamily: "var(--family1)", fontSize: '14px', background: 'linear-gradient(127deg, rgba(7,213,255,1) 0%, rgba(16,34,121,1) 50%, rgba(188,150,255,1) 100%)', backgroundClip: "text", color: 'transparent' }}>Need More credits...</Typography>
          <Typography onClick={(e)=>{
            e.preventDefault();
            e.stopPropagation();
          }} sx={{ fontWeight: '600', fontFamily: "var(--family1)", fontSize: '12px', display: 'flex', alignItems: 'center', color: 'white', padding: '5px 10px', borderRadius: '5px',zIndex:'99999999 !important' }} className="upgradePlanButton-hover upgradePlanButton">
            <Link to={`/subscription/active/details/${getCompanyid()}`} className="text-decoration-none" style={{ color: 'white' }}> <img src={diamond} alt="myPlanIcon" height={18} width={18} /> Upgrade Plan</Link>
          </Typography>
        </Stack>
      </Stack>
    </>
  )
}

const sidebarData = [
  {
    title: "Dashboard",
    endpoint: "/",
    type: "dashboard",
    icon: dashboard,
    userType: ["admin", "brand", "company"],
    isActive: ["dashboard"],
    items: []
  },
  {
    title: "Discovery",
    endpoint: ROUTES.DISCOVER_INFLUNCERS,
    icon: discovery,
    userType: ["admin", "company"],
    type: "influncers",
    isActive: ["discover-influencers"],
    items: []
  },
  // no need to process on stage for now
  {
    title: "List",
    endpoint: "/list",
    type: "list",
    icon: list,
    userType: ["brand", "company"],
    isActive: ["list"],
    items: []
  },
  {
    title: "Wallet",
    endpoint: "/wallet",
    type: "wallet",
    icon: wallet,
    userType: ["admin", "brand", "company"],
    isActive: ["wallet"],
    items: []
  },
  {
    title: "Creator Management",
    endpoint: ROUTES.USER_MANAGEMENT,
    icon: usermgt,
    type: "users",
    userType: ["admin"],
    isActive: ["userManagement", 'createInfluencer', 'editInfluencer'],
    items: []
  },
  {
    title: "My Campaigns",
    endpoint: ROUTES.MY_CAMPAIGNS,
    icon: mycampaigns,
    userType: ["brand", "company"],
    type: "myCampaign",
    isActive: ["my-campaign", "campaign"],
    items: []
  },
  {
    title: "Company Management",
    endpoint: ROUTES.COMPANIES,
    icon: company,
    type: "company",
    userType: ["admin",],
    isActive: ["companies", "company"],
    items: []
  },

  {
    title: "Brands",
    endpoint: ROUTES.BRANDS_FOR_COMPANY,
    icon: brands,
    type: "brand",
    userType: ["brand", "company"],
    isActive: ["brands"],
    items: []
  },
  {
    title: "Campaign Management",
    endpoint: ROUTES.CAMPAIGN_MANAGEMENT,
    icon: campaign,
    type: "campaign",
    userType: ["admin"],
    isActive: ["campaign", "my-campaigns"],
    items: []
  },

  {
    title: "Admin User",
    endpoint: ROUTES.ADMIN_USERS,
    icon: users,
    type: "adminUsers",
    userType: ["admin"],
    isActive: ["adminUsers"],
    items: []
  },
  {
    title: "Roles & Rights Mgt.",
    endpoint: ROUTES.ROLES_AND_RIGHTS,
    icon: roles,
    userType: ["admin"],
    type: "roleAndRights",
    isActive: ["roles"],
    items: []
  },
  {
    title: "Subscription  Mgt.",
    endpoint: ROUTES.SUBSCRIPTION_MGT,
    icon: subscription,
    type: "roleAndRights",
    userType: ["admin"],
    isActive: ["subscriptions", "subscription"],
    items: []
  },
  {
    title: "Notifications",
    icon: notification,
    type: "notification",
    userType: ["admin"],
    isActive: ["notification"],
    items: [
      {
        title: "Notification Groups",
        endpoint: ROUTES.GROUP_NOTIFICATION,
        isActive: ["group", 'group-edit', 'add'],
      },
       {
        title: "Community Posts",
        endpoint: ROUTES.COMMUNITY_POSTS,
        isActive: ["communityposts", 'edit', 'add'],
      },
      {
        title: "Notification Editor",
        endpoint: ROUTES.NOTIFICATION_EDITOR,
        isActive: ["editor"],
      },
      {
        title: "Notification History",
        endpoint: ROUTES.NOTIFICATION_HISTORY,
        isActive: ['history', 'edit'],
      }
    ]
  },
  {
    title: "Subscriptions",
    icon: subscription,
    type: "subscription",
    userType: ["company"],
    isActive: ["subscriptions", "subscription"],
    items: [
      {
        title: "Subscription Plan",
        endpoint: ROUTES.SUBSCRIPTION_FOR_COMPANY,
        isActive: ['active'],
        icon: subscription,
      },
      {
        title: "Subscription History",
        endpoint: ROUTES.SUBSCRIPTION_HISTORY,
        isActive: ['history'],
        icon: subscription,
      }
    ]
  },
  {
    title: "Audit Trail",
    endpoint: ROUTES.AUDIT_TRAILS,
    icon: audits,
    type: "auditTrail",
    userType: ["admin"],
    isActive: ["auditTrails"],
    items: [

    ]
  },
  {
    title: "KYC",
    endpoint: ROUTES.KYC,
    icon: kyc,
    type: "kyc",
    userType: ["admin"],
    isActive: ["kyc"],
    items: [

    ]
  },
  {
    title: "Privacy policy",
    endpoint: ROUTES.PRIVACY_POLICY,
    icon: privacy,
    type: "privacyPolicy",
    userType: ["admin"],
    isActive: ["privacyPolicy"],
    items: []
  },

];
const HoveredList = styled(List)(({ theme, sx }) => ({
  position: "fixed",
  top: 0,
  left: 0,
  height: "100vh",
  overflowY: "auto",
  zIndex: '99',
  padding: '0px 16px',
  transition: `"all ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut}"`,

  overflowX: "hidden",
  ...sx,
}));

const StyledListItem = styled(ListItemButton)(({ theme }) => ({
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  margin: "0px 3px",
  borderRadius: "15px",

  color: "#6C7692",
  position: "relative",
  "&:hover, &.active": {
    background: 'rgba(0, 119, 255, 0.10)',
    color: "rgba(0, 119, 255, 1)",
    "& .listItemIcon": {
      color: "rgba(0, 119, 255, 1)",
    },
  },
}));

const SidebarMobile = () => {
  const theme = useTheme();
  const states = useSelector((state) => state.app);
  const { userInfo } = useSelector((state) => state.commonSlice);
 const [openCredTooltip,setOpenCredTooltip] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(location?.pathname?.split("/")[1]);
  const [type, setType] = useState(-1);
  const {
    planDetails } = useSelector((state) => state.subscriptionSlice);
  const [anchorEl, setAnchorEl] = useState(null);
  const open1 = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setTimeout(() => {
      setAnchorEl(null);
    }, 0);
  };
  const userType = JSON.parse(localStorage.getItem("user"));
  let sideBarJson = [];
  if (userType?.userType === "company") {
    sideBarJson = {
      brands: { edit: 1, view: 1, create: 1, delete: 1 },
      users: { edit: 1, view: 1, create: 1, delete: 1 },
      myCampaigns: { edit: 1, view: 1, create: 1, delete: 1 },
      dashboard: { edit: 1, view: 1, create: 1, delete: 1 },
      searchInculencer: { edit: 1, view: 1, create: 1, delete: 1 },
    }
  }
  else {
    sideBarJson = sidebarData.reduce((acc, item) => {
      const type = item.type;
      acc[type] = { edit: 1, view: 1, create: 1, delete: 1 };
      return acc;
    }, {});
  }
  const handleToggleSidebar = (e) => {
    e.preventDefault();
    dispatch(setSidebar());
  };

  useEffect(() => {
    dispatch(getUserInfoNew(userType?.id));

  }, []);


  return (
    states.permissions && (
      <>
        <HoveredList
          className={`sidebar ${!states.sidebar ? 'activeSidebar' : ''}`}
          sx={{
            maxWidth: `${!states.sidebar ? "255px !important" : "80px !important"}`,
            width: "100%",
            backgroundColor: "background.paper",
            zIndex: 1000,
          }}
        >
          <Link to="/" className="sidebarLogo" style={{float:'left'}}>
           {!states.sidebar &&  <Box sx={{
                      visibility:'visible !important',opacity:'1 !important',width:'100% !important'
                    }} className="fullLogo" component="img" src={logo}></Box>
          }
          </Link>
          <div className="closeSidebar" onClick={handleToggleSidebar} >
            <KeyboardDoubleArrowLeftIcon />
          </div>

          {states.permissions && sidebarData.map((item, index) =>
            states.permissions?.[item.type]?.view !== 0 &&
            item?.userType?.includes(JSON.parse(localStorage.getItem("user"))?.userType) && (
              <React.Fragment key={index}>
                <ListItem onClick={() => {
                  if (item.items.length > 0) {
                    setType((prevType) => prevType === item.type ? -1 : item.type);
                    setOpen((prevOpen) => prevOpen === item.type ? "" : item.type);
                  } else {
                    navigate(item.endpoint);
                  }
                }}>

                  <StyledListItem
                    className={item?.isActive?.includes(location?.pathname?.split("/")[1]) ? "active" : ""}
                    disableRipple
                    component={item.items.length > 0 ? 'div' : NavLink}
                    to={item.items.length === 0 ? item.endpoint : false}
                  >
                    <ListItemIcon className="listItemIcon">
                      <Image src={item.icon} className='img-fluid' alt="" />
                    </ListItemIcon>
                    <ListItemText className="tabText m-0" disableTypography primary={item.title}  sx={{
                      visibility:'visible !important',opacity:'1 !important'
                    }}/>
                    {item.items.length > 0 && (open === item.type ? <ExpandLess sx={{
                      display:'block !important'                    }}/> : <ExpandMore sx={{
                      display:'block !important'
                    }}/>)}
                  </StyledListItem>
                </ListItem>
                {item.items.length > 0 && (
                  <Collapse className="dropParent" in={open === item.type} timeout="auto" unmountOnExit>
                    {item.items.map((v, subIndex) => (
                      <List component="div" className="dropIt" disablePadding key={subIndex}>
                        <ListItemButton sx={{ pl: 6,visibility:'visible !important',opacity:'1 !important' }}
                          className={v?.isActive?.includes(location?.pathname?.split("/")?.slice(-1)?.pop()) ? "activeItem" : ""}
                          onClick={() => navigate(v.endpoint)}
                        >
                          <div className="bulletIcon"></div>
                          <div className="textSubTab">{v.title}</div>
                        </ListItemButton>
                      </List>
                    ))}
                  </Collapse>
                )}
              </React.Fragment>
            )
          )}


          {getUserType() === COMPANY && <ListItem
            className="versionControl"
            sx={{
              paddingX: "16px",
              marginY: '16px',
              display: "flex",
              bottom: "20px",
              justifyContent: "left",
              position: "absolute",
              left: '0',
              transition: `all ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut}`,
            }}
          >
            <Stack direction="row" spacing={1} alignItems="center" 
              sx={{
                padding: '0px !important', position: 'relative', background: 'inherit',
              }}>
              <Tooltip title="Account settings" >
                <IconButton
                  size="small"  onClick={handleClick}
                  sx={{ ml: 2, }}
                  aria-controls={open1 ? 'account-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={open1 ? 'true' : undefined}
                >
                  <Avatar alt={getCompanyName()} src={userInfo?.photoUrl ? userInfo?.photoUrl : "/"} />
                </IconButton>
                <Stack direction="row" className={`creditsTooltipSmall  `} alignItems="center" sx={{
                  visibility: (!states.sidebar || anchorEl) && "hidden !important",
                  opacity: (!states.sidebar || anchorEl) && "0 !important", pointerEvents: 'none', marginLeft: '16px', padding: '4px 10px', fontSize: '10px', fontWeight: '700', width: '50px', textAlign: 'center', borderRadius: '50px', color: "white", background: "var(--color-blue)",
                }} >
                  <img style={{ height: '10px', width: '10px', filter: 'none' }} src={creditWhite} alt="creditWhite" />&nbsp;&nbsp;
                  {getFixedValueToNonDecimal(getFormatedNumber(planDetails?.basicInfo?.useSearchView) + getFormatedNumber(planDetails?.basicInfo?.useProfileView) + getFormatedNumber(planDetails?.basicInfo?.usePhoneNumber) + getFormatedNumber(planDetails?.basicInfo?.useEmail) + getFormatedNumber(planDetails?.basicInfo?.useInfluencerApproved) + getFormatedNumber(planDetails?.basicInfo?.usePaid) + getFormatedNumber(planDetails?.basicInfo?.useBarter) + getFormatedNumber(planDetails?.basicInfo?.useAffiliate) + getFormatedNumber(planDetails?.basicInfo?.usePerformance))}
                </Stack>
              </Tooltip>
              <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={Boolean(anchorEl)}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
                getContentAnchorEl={null}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: 'visible',
                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                    mt: -1,
                    '& .MuiAvatar-root': {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,

                    },
                    '&::before': {
                      content: '""',
                      display: 'block',
                      position: 'absolute',
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: 'background.paper',
                      zIndex: 0,
                    },
                    '& .MuiMenuItem-root': {
                      padding: '12px 6px 8px 6px', borderBottom: '1px solid #EEEEEE', paddingLeft: '16px'
                    },
                    "& ul": {
                      display: 'flex',
                      flexDirection: 'column', padding: '0', gap: '0px'
                    },
                    width: '200px',
                    height: '175px',
                    fontSize: '14px',
                    fontWeight: '400',
                    color: '#565656',
                    borderRadius: '12px',
                    border: '1px solid #EEEEEE',
                    boxShadow: '0px 4px 12px 0px #0000001F',
                  },
                }}
                anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
                transformOrigin={{ horizontal: 'left', vertical: 'bottom' }}
              >
                {getUserType() === COMPANY && <>
                  <MenuItem onClick={() => {
                    handleClose();
                    dispatch(getCompanyDetails(getCompanyid(), navigate))
                  }}>
                    <ListItemIcon>
                      <img src={user} width={20} height={20} alt="user" />
                    </ListItemIcon>
                    Profile<ListItemIcon sx={{ marginLeft: "auto", }}>
                    </ListItemIcon>
                  </MenuItem>
                  <MenuItem onClick={() => {
                    handleClose();
                    navigate(ROUTES.SUBSCRIPTION_FOR_COMPANY)
                  }}>
                    <ListItemIcon>
                      <img src={viewSubscription} width={20} height={20} alt="user" />
                    </ListItemIcon> View Subscription<ListItemIcon sx={{ marginLeft: "auto", }}>
                    </ListItemIcon>
                  </MenuItem>
                  <MenuItem onClick={() => {
                    handleClose();
                    navigate(ROUTES.COMPANY_USERS)

                  }}>
                    <ListItemIcon>
                      <img src={manageUser} width={20} height={20} alt="user" />
                    </ListItemIcon>Manage Users<ListItemIcon sx={{ marginLeft: "auto", }}>
                    </ListItemIcon>
                  </MenuItem>
                </>}

                <MenuItem onClick={() => {
                  handleClose();
                  dispatch({ type: 'USER_LOGOUT' });
                  persistor.purge();
                  localStorage.clear();
                  navigate(ROUTES.LOGIN)
                }}>
                  <ListItemIcon>
                    <img src={logoutIcon} width={20} height={20} alt="user" />
                  </ListItemIcon>
                  Logout
                  <ListItemIcon sx={{ marginLeft: "auto", }}>
                  </ListItemIcon>
                </MenuItem>
              </Menu>
              <Stack direction="column"
                sx={{
                  width:'160px',marginLeft:'-5px',
                  border: '0',transition: `all ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut}`,
                }} >
                <Typography
                  onClick={handleClick}
                  variant="subtitle1"
                  className="username text-capitalize"
                  fontSize="15px"
                  fontWeight={600}
                  sx={{ color: '#000' }}>

                  {userType?.userType === "company" ? userInfo?.companyName || userInfo?.contactPersonName : userInfo?.adminName}
                  <ExpandMoreOutlinedIcon sx={{ color: '#000', marginLeft: '5px',rotate:anchorEl ? '180deg' : '0'}} disableRipple />
                </Typography>
                <Typography
                  onClick={handleClick}
                  className="userCat text-capitalize"
                  variant="subtitle2"
                  fontWeight={500}
                  fontSize="12px"
                  sx={{ color: "#07C325" }}
                >
                  {getUserType()}
                </Typography>
                <Box
                  className={`userCat text-capitalize ${states.sidebar ?  "creditsTooltipFull" : ''}`}
                  variant="subtitle2"
                  fontWeight={700}
                  fontSize="10px"
                  sx={{
                    padding: '4px 10px',marginLeft:'-5px',fontWeight:'700',fontSize:'12px', textAlign: 'center', borderRadius: '50px', color: "white", background: "var(--color-blue)", visibility: anchorEl && "visible !important",
                    opacity: anchorEl && "1 !important",marginTop:'5px',
                  }}
                >
                  <Tooltip open={openCredTooltip}
  onClose={() => setOpenCredTooltip(false)}
  onOpen={() => setOpenCredTooltip(true)} placement="bottom-start" arrow componentsProps={{
                    tooltip: {
                      sx: {
                        marginTop: '3px !important',
                        backgroundColor: "white !important",
                        color: "black !important",
                        borderRadius: '5px',
                        boxShadow: '0px 0px 24px 0px #0077FF33',
                        width: '363px', height: '194px', paddingX: '0 !important', paddingY: '5px !important', maxWidth: '100%'
                      },
                    },
                    arrow: {
                      sx: {
                        color: "transparent !important",
                        "&::before": {
                          backgroundColor: "transparent",
                        },
                      },
                    },
                  }} title={<UserInfo  planDetails={planDetails}/>}>
                    <Stack onClick={()=>setOpenCredTooltip(!openCredTooltip)} direction="row" alignItems="center" justifyContent="space-evenly" >
                      {getFixedValue(getFormatedNumber(planDetails?.basicInfo?.useSearchView) + getFormatedNumber(planDetails?.basicInfo?.useProfileView) + getFormatedNumber(planDetails?.basicInfo?.usePhoneNumber) + getFormatedNumber(planDetails?.basicInfo?.useEmail) + getFormatedNumber(planDetails?.basicInfo?.useInfluencerApproved) + getFormatedNumber(planDetails?.basicInfo?.usePaid) + getFormatedNumber(planDetails?.basicInfo?.useBarter) + getFormatedNumber(planDetails?.basicInfo?.useAffiliate) + getFormatedNumber(planDetails?.basicInfo?.usePerformance))} Credits Remai..&nbsp;<img src={infoWhite} alt="infowhite" style={{ height: '14px', width: '14px', filter: 'none' }} />
                    </Stack>
                  </Tooltip>
                </Box>
              </Stack>
            </Stack>
          </ListItem>}
        </HoveredList >

      </>
    )
  );
};

export default SidebarMobile;
